var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DEFAULT_TEXTS_MONTH = {
    shortSunday: 'Su',
    shortMonday: 'Mo',
    shortTuesday: 'Tu',
    shortWednesday: 'We',
    shortThursday: 'Th',
    shortFriday: 'Fr',
    shortSaturday: 'Sa'
};
export var DEFAULT_TEXTS = __assign({ january: 'January', february: 'February', march: 'March', april: 'April', may: 'May', june: 'June', july: 'July', august: 'August', september: 'September', october: 'October', november: 'November', december: 'December', today: 'Today' }, DEFAULT_TEXTS_MONTH);
export var dataSelectorId = {
    prevMonthControl: 'prev-month-control',
    monthSelectorControl: 'selector-control',
    nextMonthControl: 'next-month-control',
    todayControl: 'today-control'
};
//# sourceMappingURL=helpers.js.map